import { ref, watchEffect } from 'vue';

const useTableSort = (props, localizationSupport) => {
  const sort = ref(props.defaultSort);
  const sortKeys = ref();
  watchEffect(() => {
    sort.value = props.defaultSort;
  });
  const { translate } = localizationSupport;
  const onTableHeaderClick = (header) => {
    if (header.sortKey && isHeaderSortable(header)) {
      updateSort(header);
    }
  };
  const tableHeaderAttributes = (header) => {
    var _a, _b;
    return {
      tabindex: isHeaderSortable(header) ? 0 : void 0,
      class: { "fds-table__header--sortable": isHeaderSortable(header), "fds-table__header--sorted": isHeaderSorted(header) },
      "aria-sort": (_a = getAriaSort(header)) != null ? _a : void 0,
      "aria-label": (_b = getSortLabel(header, header.label)) != null ? _b : void 0
    };
  };
  const tableHeaderEvents = (header) => {
    return {
      click: (e) => {
        e.preventDefault();
        onTableHeaderClick(header);
      },
      keyup: (e) => {
        if (e.key === "Enter") {
          onTableHeaderClick(header);
        }
      }
    };
  };
  const tableSortIconAttributes = (header) => {
    var _a, _b;
    return {
      "aria-hidden": true,
      class: {
        "fds-table__sort-icon": true,
        [`fds-table__sort-icon--${(_b = (_a = sort.value) == null ? void 0 : _a.direction) != null ? _b : ""}`]: isHeaderSorted(header)
      }
    };
  };
  const isHeaderSortable = (header) => {
    var _a, _b, _c;
    if (header.sortKey === void 0) {
      return false;
    }
    return (_c = (_b = (_a = sortKeys.value) == null ? void 0 : _a[header.sortKey]) == null ? void 0 : _b.canSort) != null ? _c : false;
  };
  const isHeaderSorted = (header) => {
    var _a;
    return isHeaderSortable(header) && header.sortKey === ((_a = sort.value) == null ? void 0 : _a.key);
  };
  const getAriaSort = (header) => {
    var _a;
    if (isHeaderSorted(header)) {
      return ((_a = sort.value) == null ? void 0 : _a.direction) === "desc" ? "descending" : "ascending";
    }
    if (isHeaderSortable(header)) {
      return "none";
    }
    return null;
  };
  const getSortLabel = (header, label) => {
    var _a;
    const field = translate(label);
    if (isHeaderSorted(header)) {
      return ((_a = sort.value) == null ? void 0 : _a.direction) === "desc" ? translate("tableSort.sorted.descending", { field }) : translate("tableSort.sorted.ascending", { field });
    }
    if (isHeaderSortable(header)) {
      return translate("tableSort.notSorted.ascending", { field });
    }
    return null;
  };
  const updateSort = (header) => {
    var _a, _b, _c;
    if (header.sortKey !== void 0) {
      const sortDirection = (_b = (_a = sort.value) == null ? void 0 : _a.direction) != null ? _b : "asc";
      sort.value = {
        key: header.sortKey,
        direction: ((_c = sort.value) == null ? void 0 : _c.key) === header.sortKey && sortDirection === "asc" ? "desc" : "asc"
      };
    }
  };
  const getTableSortInputs = () => {
    return { defaultSort: sort.value };
  };
  return {
    sort,
    sortKeys,
    isHeaderSortable,
    isHeaderSorted,
    getAriaSort,
    getSortLabel,
    updateSort,
    getTableSortInputs,
    onTableHeaderClick,
    tableHeaderAttributes,
    tableHeaderEvents,
    tableSortIconAttributes
  };
};

export { useTableSort };
